import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import React from 'react'
import { MenuItem, RefreshIndicator, SelectField, TextField } from 'material-ui'

import Button from '../../../../sitewide/Button'
import CloseButton from './CloseButton'
import Label from '../Label'
import { validCustomTime } from '../helpers'

import autoBookingStyles from './autoBookingPopover.css'
import bookingPopoverStyles from '../styles/bookingPopover.css'

// TODO: Break up this component
const AutoBookingPopover = ({
  appointmentTimes,
  autoAptTime,
  doctor,
  doctors,
  handleValueUpdate,
  locationName,
  onClose,
  onDeleteConfirm,
  onSubmit,
  patientFullName,
  renderDoctorOptions,
  selectedBooking,
  showSpinner,
  submitDisabled,
  timeDropdownValue,
}) => {
  const floatingLabelBaseStyle = {
    color: 'rgba(0,0,0,0,5)',
    left: 0,
    right: 0,
    margin: 'auto',
    transformOrigin: 'center',
  }

  return (
    <div className={bookingPopoverStyles.popover}>
      <div className={autoBookingStyles.headerRow}>
        <h1 className={autoBookingStyles.mainMessage}>
          {selectedBooking.start.format('MMMM D, YYYY')}
        </h1>
        <CloseButton onClose={onClose} />
      </div>
      <div>
        <p className={autoBookingStyles.secondaryMessage}>
          {
            `Select a start time and click Create Booking to notify ${patientFullName()} of their appointment time.`
          }
        </p>
      </div>
      <div className={autoBookingStyles.timeSelectRow}>
        <SelectField
          className={bookingPopoverStyles.selectField}
          floatingLabelFixed
          floatingLabelText="start time"
          floatingLabelStyle={floatingLabelBaseStyle}
          maxHeight={250}
          onChange={(e, key, value) => {
            handleValueUpdate('autoAptTime', value)
          }}
          value={timeDropdownValue}>
          {appointmentTimes.map((time) => {
            const value = moment.isMoment(time) ? time.format('h:mm a') : time
            const timeVal = moment.isMoment(time) ? time.format('HH:mm') : time
            return (
              <MenuItem value={timeVal} key={timeVal} primaryText={value} />
            )
          })}
        </SelectField>
      </div>
      <div className={autoBookingStyles}>
        {validCustomTime(appointmentTimes, autoAptTime) && (
          <TextField
            type={'time'}
            name={'time'}
            onChange={(e, value) => {
              if (value) {
                handleValueUpdate('autoAptTime', value)
              }
            }}
          />
        )}
      </div>
      <div className={autoBookingStyles.bottomSelectRow}>
        <div className={autoBookingStyles.doctorSelect}>
          <SelectField
            className={bookingPopoverStyles.selectField}
            floatingLabelFixed
            floatingLabelText="doctor"
            floatingLabelStyle={floatingLabelBaseStyle}
            maxHeight={250}
            style={{
              width: '200px',
            }}
            value={doctor || doctors[0].id}
            onChange={(e, key, value) => {
              handleValueUpdate('doctor', value)
            }}>
            {renderDoctorOptions()}
          </SelectField>
        </div>
        <div className={autoBookingStyles.locationSelect}>
          <Label>location</Label>
          <div className={autoBookingStyles.location}>{locationName}</div>
        </div>
      </div>
      <div className={autoBookingStyles.buttonRow}>
        <Button
          buttonClass="delete"
          paddingTB="8px"
          paddingLR="30px"
          onClick={onDeleteConfirm}>
          delete
        </Button>
        <Button
          buttonClass="submit"
          paddingTB="8px"
          paddingLR="30px"
          onClick={onSubmit()}
          disabled={submitDisabled}>
          create booking
        </Button>
        {showSpinner && (
          <div className={autoBookingStyles.spinner}>
            <RefreshIndicator size={60} left={0} top={0} status="loading" />
          </div>
        )}
      </div>
    </div>
  )
}

AutoBookingPopover.propTypes = {
  appointmentTimes: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  ).isRequired,
  autoAptTime: PropTypes.string,
  doctor: PropTypes.string.isRequired,
  doctors: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleValueUpdate: PropTypes.func.isRequired,
  locationName: PropTypes.string,
  onClose: PropTypes.func,
  onDeleteConfirm: PropTypes.func,
  onSubmit: PropTypes.func,
  renderDoctorOptions: PropTypes.func,
  selectedBooking: PropTypes.shape({
    start: PropTypes.object,
  }).isRequired,
  showSpinner: PropTypes.bool.isRequired,
  submitDisabled: PropTypes.bool.isRequired,
  timeDropdownValue: PropTypes.string,
}

export default AutoBookingPopover



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/BookingPopover/AutoBookingPopover/AutoBookingPopover.js